<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Client Types</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    fixed-header
    :headers="headers"
    :items="confirmedClientTypes ? allClientTypes : allClientTypes.filter(a => a.CheckerID === 0)"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <v-dialog persistent v-model="rejectionDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">ok</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteDialog" max-width="350px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">yes</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New Client Type</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-text-field
            dense filled
            color="#2A353D"
            v-model="client_type.ShortCode"
            label="Code"
            required
            :rules="code"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="client_type.ClientType"
            label="Client Type"
            required
            :rules="[
              v => !!v || 'field is required',
              v => (v && v.length <= 50) || 'field must be less than 50 characters'
            ]"
          ></v-text-field>           
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="client_type.Description"
            label="Description"
            required
            :rules="[
              v => !!v || 'field is required',
              v => (v && v.length <= 50) || 'field must be less than 50 characters'
            ]"
          ></v-text-field>
          <div class="text-right">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
            <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
          </div>   
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Client Type: {{currentClientType.ClientType.toUpperCase()}}</v-toolbar-title>
          <v-spacer/>
          <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentClientType.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span v-if="currentClientType.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentClientType.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentClientType.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-text-field
            dense filled
            color="#2A353D"
            v-model="currentClientType.ShortCode"
            label="Code"
            :readonly="view"
            required
            :rules="code"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            :readonly="view"
            v-model="currentClientType.ClientType"
            label="Client Type"
            required
            :rules="[
              v => !!v || 'field is required',
              v => (v && v.length <= 50) || 'field must be less than 50 characters'
            ]"
          ></v-text-field>           
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            :readonly="view"
            v-model="currentClientType.Description"
            label="Description"
            required
            :rules="[
              v => !!v || 'field is required',
              v => (v && v.length <= 50) || 'field must be less than 50 characters'
            ]"
          ></v-text-field>     
          <div class="text-right">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
            <v-btn class="white--text mr-3" v-if="!view" small color="#2A353D" @click="update()">save</v-btn>          
          </div>
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>
      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedClientTypes" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <!-- <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedClientTypes" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-if="confirmedClientTypes" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn> -->
        <v-btn v-if="!confirmedClientTypes" @click="confirmedClientTypes = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedClientTypes && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveClientType(item, index); updateStatus()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedClientTypes && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveClientType(item, index); rejectionDialog = true"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedClientTypes"
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActiveClientType(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        @click="view = true; setActiveClientType(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-icon
        :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
        color="#2A353D" @click="setActiveClientType(item, index); deleteDialog = true"
      >
      mdi-trash-can-outline
      </v-icon>
    </template>

    <template v-slot:item.MakeDate="{ item }">
      {{ item.MakeDate | moment("DD MMMM YYYY") }}
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';

export default {
  name: 'client_types',

  data () {
    return {
      confirmedClientTypes: true,
      edit: false,
      create:false,
      view: false,
      rejectionDialog: false,
      RejectionStatus: 0,
      deleteDialog: false,
      permitted: null,
      permitted_dialog: true,
      message: '',
      search: '',
      valid: true,
      content: '',
      currentClientType: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Code',
          align: 'start',
          sortable: true,
          value: 'ShortCode'
        },
        { text: 'Client Type', value: 'ClientType', sortable: false },
        { text: 'Description', value: 'Description', sortable: false },
        { text: 'Date created', value: 'MakeDate', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      code: [
        v => !!v || 'field is required',
        v => (v && v.length <= 3) || 'Code can only be 3 Characters long'
      ],
      client_type: {},
      submitted: false,
    }
  },

  computed: {
    ...mapGetters([
      "allClientTypes",
      "allRejectionReasons",
      "allUsers",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 407).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 407).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 407).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 407).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 407).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createClientType",
      "updateClientType",
      "deleteClientType"
    ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.client_type.MakerID = this.currentUser.SecurityUserID,
        this.client_type.CheckerID = this.CheckerID,
        this.client_type.LastUserID = this.currentUser.SecurityUserID,
        this.createClientType(this.client_type)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newClientType',
            data: response.data
          });
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    async update() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        if(this.currentClientType.CheckerID == 0){
          this.currentClientType.LastUserID = this.currentUser.SecurityUserID,
          this.currentClientType.RejectionID = this.RejectionStatus,
          this.currentClientType.CheckerID = 0,
          this.currentClientType.CheckDate = null,

          this.updateClientType(this.currentClientType)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updClientType',
              data: this.currentClientType
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })   
        } else {
          this.currentClientType.MakerID = this.currentUser.SecurityUserID
          this.currentClientType.LastUserID = this.currentUser.SecurityUserID,
          this.currentClientType.RejectionID = this.RejectionStatus,
          this.currentClientType.CheckerID = 0,
          this.currentClientType.CheckDate = null,
          this.currentClientType.MakeDate = new Date(),

          this.updateClientType(this.currentClientType)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updClientType',
              data: this.currentClientType
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })   
        }
      }
    },

    deleteItem() {
      this.message = '';
      this.deleteClientType(this.currentClientType)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltClientType',
          data: this.currentClientType
        });
        this.message = response.data.message;
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.deleteDialog = false
      })        
    },

    updateStatus() {
      this.message = '';

      this.currentClientType.CheckerID = this.currentUser.SecurityUserID,
      this.currentClientType.LastUserID = this.currentUser.SecurityUserID,
      this.currentClientType.RejectionID = this.RejectionStatus,
      this.currentClientType.CheckDate = new Date(),
      this.currentClientType.updatedAt = new Date(),

      this.updateClientType(this.currentClientType)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updClientType',
          data: this.currentClientType
        });
        
        this.message = response.data.message;
        this.rejectionDialog = false;
        this.RejectionStatus = 0
        this.closeEdit()
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.rejectionDialog = false;
        this.RejectionStatus = 0
      })
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedClientTypes = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.client_type = {};
      this.create = false
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    setActiveClientType (item, index) {
      this.currentClientType = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isClientTypes().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedClientTypes", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
